module.exports = __webpack_public_path__ + "static/media/28.1 burger-logo.png.b8503d26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/28.1 burger-logo.png.png
// module id = 96
// module chunks = 0